import { AcceptableSsoInvitationResponseDto } from '@lucidlink/dto/web-service-api';
import { arrayToAesKey, base64ToArray, decryptWithAes, } from '@lucidlink/ts-crypto/crypto';
import { parserFromDto } from '#fetcher';
import { InvalidDomainSecretError } from '#types/sdk';
export const createAccessTokenFetcher = (unauthenticatedFetcher, accessToken, args) => {
    return unauthenticatedFetcher.createSubFetcher({
        ...args,
        getAccessToken: (_) => Promise.resolve(accessToken),
    });
};
export const verifySsoOperation = async (params) => {
    const ssoFetcher = createAccessTokenFetcher(params.unauthenticatedFetcher, params.accessToken, {});
    const ssoInvitation = await ssoFetcher.get(['invitations', 'sso'], {
        parser: parserFromDto(AcceptableSsoInvitationResponseDto),
    });
    try {
        const receivedKey = typeof params.domainKey === 'string'
            ? await arrayToAesKey(base64ToArray(params.domainKey))
            : params.domainKey;
        if (ssoInvitation.eSsoSecretByDomainKey) {
            await decryptWithAes(ssoInvitation.eSsoSecretByDomainKey, receivedKey);
        }
        else {
            await decryptWithAes(ssoInvitation.ePrivateKeyBySsoSecret, receivedKey);
        }
    }
    catch {
        throw new InvalidDomainSecretError();
    }
    return {
        ssoFetcher,
        ssoInvitation,
    };
};
